import React, { useMemo, useContext, useEffect, useState, useCallback } from 'react'
import { Content, DetailsBody, DetailsContainer, DetailsContent, DetailsTitle, HeaderDetails, InfoDetails, InfoText, SupportContainer, Text, TicketContainer, TicketTitle } from './styled'
import Input from 'components/Form/Input'
import Button from 'components/Form/Button'
import { StatusContent } from 'ui/styled'
import CardsList from 'components/Form/TableCard'
import { CoreContext } from 'context/CoreContext'
import { useParams, useHistory } from 'react-router-dom'
import useForm from 'hooks/useForm'
import moment from 'moment/moment'
import useI18n from 'hooks/useI18n'
import { useAuthLayout } from 'context/AuthLayoutContext'

export default function SupportDetails() {
  const history = useHistory();
  const { setLayoutProps } = useAuthLayout();

  const { setModal, user } = useContext(CoreContext);

  const { id } = useParams()

  const { t } = useI18n()

  const [form, setForm] = useState({})
  const formValue = ref => { return form?.[ref] ? form?.[ref] : ''; }
  const changeForm = (value, ref) => { setForm({ ...form, [ref]: value }); }

  const { register, save, loading } = useForm({ table: "supports", id })

  const rows = useMemo(() => [
    {
      ...register,
      ticket: register?.id,
      createdDate: moment(register?.createdAt)?.format("L"),
      subject: register?.title,
      lastUpdated: moment(register?.updatedAt)?.format("L"),
      category: register?.industry,
      status: register?.status,
    },
  ], [register]);

  const reply = async () => {
    await save({
      messages: [
        ...(register?.messages || []),
        {
          title: user?.firstName,
          description: form?.reply,
          mine: true
        }
      ]
    })
    setForm({})
  }

  const handleClose = useCallback(async (p) => {
    await save({
      ...(p || {}),
      status: "closed"
    })
    history?.goBack()
  }, [history, save])

  const columns = useMemo(() => [
    { title: t('ticket_id'), ref: 'ticket' },
    { title: t('created_date'), ref: 'createdDate' },
    { title: t('category_department'), ref: 'category' },
    {
      title: t('status'), ref: 'status', renderCell: ({ row }) =>
        <><StatusContent color={row?.status}>{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1).toLowerCase()}</StatusContent></>
    },
    {
      title: '', ref: 'action', renderCell: () =>
        <Button outline small color='primary' nospace onClick={() => setModal({ type: 'feedback', save: async p => await handleClose(p) })}>
          {t('close_ticket')}
        </Button>
    },
  ].filter(f => f), [handleClose, setModal, t]);

  useEffect(() => {
    setLayoutProps({ headerSecondary: true })

    return () => setLayoutProps({})
  }, [setLayoutProps])

  return (

    <Content>

      <DetailsContent>
        <DetailsContainer>
          <DetailsBody>
            <DetailsTitle>
              {register?.title}
            </DetailsTitle>
            <InfoDetails>
              <InfoText>{register?.user?.firstName}</InfoText>
              <InfoText>{moment(register?.createdAt)?.format("L HH:mm")}</InfoText>
            </InfoDetails>
            <Text>
              {register?.description}
            </Text>
          </DetailsBody>
          {
            register?.messages?.map((m, k) =>
              <SupportContainer key={`${m?.createdAt || 'message'}-${k}`} mine={m?.mine}>
                <HeaderDetails>
                  <InfoText>{m?.title}</InfoText>
                  <InfoText>{moment(m?.createdAt)?.format("L HH:mm")}</InfoText>
                </HeaderDetails>
                <Text>
                  {m?.description}
                </Text>
              </SupportContainer>
            )
          }
          <SupportContainer white text>
            <Input type='textarea' id={'reply'} placeholder={t('add_reply')} holder value={formValue('reply')} onChange={e => changeForm(e.target.value, 'reply')} textarea />
            <Button loading={loading} onClick={reply} color='blue' width={'120px'} small>
              {t('send')}
            </Button>
          </SupportContainer>
        </DetailsContainer>
        <TicketContainer>
          <TicketTitle>{t('ticket_information')}</TicketTitle>
          <CardsList columns={columns} rows={rows} full noShadow />
        </TicketContainer>
      </DetailsContent>
    </Content>
  )
}
